import {Component, ComponentInterface, Host, Prop, State, h} from '@stencil/core';
import {SolIconSizeEnum} from '../sol-icon/types/sol-icon-sizes';
import {type SolAvatarStatus, SolAvatarStatusEnum} from './types/sol-avatar-status';
import {SolAvatarSize} from './types/sol-avatar-sizes';

@Component({
  tag: 'sol-avatar',
  styleUrl: 'sol-avatar.scss',
  shadow: true,
})
export class SolAvatar implements ComponentInterface {
  @Prop() image: string = '';

  @Prop() name: string = '';

  @Prop() status: SolAvatarStatus = SolAvatarStatusEnum.None;

  @Prop() size: SolAvatarSize = SolIconSizeEnum.s36;

  @State() imageError: boolean = false;

  private handleImageError() {
    this.imageError = true;
  }

  private renderImage() {
    return <img class="sol-avatar__img" src={this.image} alt={this.name} onError={() => this.handleImageError()} />;
  }

  private renderMonogram() {
    let initials = this.name.charAt(0);
    const nameParts = this.name.split(' ');
    if (nameParts.length > 1) {
      initials += nameParts[1].charAt(0);
    }
    return initials.toUpperCase();
  }

  private renderPlaceholder() {
    return <sol-icon-bubble icon="person" size={this.size} variant="transparent"></sol-icon-bubble>;
  }

  private getContent() {
    const showImage = this.image && !this.imageError;
    if (showImage) return this.renderImage();

    const showInitials = (!this.image || this.imageError) && this.name;
    if (showInitials) return this.renderMonogram();

    return this.renderPlaceholder();
  }

  render() {
    return (
      <Host>
        <div part="sol-avatar-background" class={`sol-avatar sol-avatar-size${this.size} sol-avatar-background`}>
          {this.getContent()}
          <div
            part="sol-indicator-border"
            class={`sol-status-indicator
          sol-status-indicator-size${this.size}
          sol-status-indicator-${this.status}
          sol-status-indicator-border${this.size}
          sol-indicator-border`}
          ></div>
        </div>
      </Host>
    );
  }
}
